import { Combo } from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";

const themeId = localStorage.getItem("themeId") || "1";

const themes = window._swivu_themes;

let currentThemePromise;

export const setTheme = async (value = themeId) => {
  const themeRecord = themes.find((theme) => theme.id === value);

  if (themeRecord) {
    // First synchronously set theme id to local storage
    localStorage.setItem("themeId", value);

    // If we're already loading style, wait for procedure to end. We probably don't need
    // to, but just to get consistent results better to wait. Otherwise the slowest loading
    // theme will be applied. And we need to apply last-picked theme
    if (currentThemePromise) {
      await currentThemePromise;
      currentThemePromise = null;
    }

    return (currentThemePromise = new Promise((resolve) => {
      const oldTheme = document.getElementById("swivu-theme");

      // Bail out if current theme is already correct
      if (oldTheme.href === themeRecord.url) {
        resolve();
      } else {
        // oldTheme.href = themeRecord.url;
        const newTheme = document.createElement("link");
        newTheme.rel = "stylesheet";
        newTheme.href = themeRecord.url;

        newTheme.onload = () => {
          // remove old theme once we've loaded new one, not before. So when we
          // remove old stylesheet there is already another one in place
          oldTheme.remove();
          newTheme.id = "swivu-theme";
          // set data-theme on body
          document.body.dataset.theme = themeRecord.themeStyle;
          resolve();
        };

        // Append theme to the doc to trigger load
        document.head.insertBefore(newTheme, oldTheme);
      }
    }));
  } else {
    console.warn("Cannot set theme");
  }
};

export default class ThemePicker extends Combo {
  static get $name() {
    return "ThemePicker";
  }

  static get type() {
    return WIDGET_KEYS.fieldThemePicker;
  }

  static get configurable() {
    return {
      editable: false,
      value: themeId,
      items: themes,
      listeners: {
        change: "handleChange"
      }
    };
  }

  handleChange({ value }) {
    setTheme(value);
  }
}

ThemePicker.initClass();
